import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import '@uh-design-system/component-library/dist/fonts/fonts.css'
import 'tippy.js/dist/tippy.css'
import '../sass/main.scss'
import initI18n from './i18n/init'
import { TopLevelRoutes } from './components/routing/TopLevelRoutes'

initI18n('fi')

createRoot(document.getElementById('thessa-application')!).render(
  <StrictMode>
    <HelmetProvider>
      <TopLevelRoutes />
    </HelmetProvider>
  </StrictMode>
)
